import { useEffect, useState } from "react";

import SpinnerComponent from "../../../Loding/Spinner";
import { IBIReport } from "../../../../Interfaces/Geral/RelatoriosBI/RelatoriosBIInterfaces";
import { TypeModulosBI } from "../../../../Services/Geral/RelatoriosBI/RelatoriosBIServices";
import { GetPowerBIReportController } from "../../../../Controllers/Geral/RelatoriosBI/RelatoriosBIControllers";

interface IRelatoriosBIProps {
    dsModuloBI: TypeModulosBI;
}

export function RelatorioBotBI(props: IRelatoriosBIProps) {
    const [report, setReport] = useState<IBIReport>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        GetPowerBIReportController(props.dsModuloBI)
            .then(setReport)
            .finally(() => {
                setLoading(false);
            });
    }, [props.dsModuloBI]);

    return (
        <div className="h-100">
            {!loading ? (
                report ? (
                    <iframe
                        title={`PowerBIReport${props.dsModuloBI}`}
                        src={
                            "https://app.powerbi.com/view?r=eyJrIjoiOGI1YjNmNmYtZjg1Yy00ZTg1LTgxMGYtNGU4MjI0Y2JlZTQ4IiwidCI6Ijc2MjZkNjViLTFkZmYtNDM5Yi04ZmNhLTc0ZGU1NTI4MmI5OSJ9"
                        }
                        className="iframe_BI y-scroll"
                        allowFullScreen={true}
                    ></iframe>
                ) : (
                    <div className="text-muted text-center">
                        Não há relatório desse módulo para ser mostrado
                    </div>
                )
            ) : (
                <SpinnerComponent />
            )}
        </div>
    );
}
